var BxfNotificationStyleEnum;
(function (BxfNotificationStyleEnum) {
    BxfNotificationStyleEnum["ERROR"] = "error";
    BxfNotificationStyleEnum["WARNING"] = "warning";
    BxfNotificationStyleEnum["SUCCESS"] = "success";
    BxfNotificationStyleEnum["MESSAGE"] = "message";
})(BxfNotificationStyleEnum || (BxfNotificationStyleEnum = {}));

export { BxfNotificationStyleEnum as B };
